import {createPrefix} from './utils';

const TABLES_PREFIX = createPrefix('TABLES');

export const TOGGLE_COLUMN_SORT_ORDER = TABLES_PREFIX + 'TOGGLE_COLUMN_SORT_ORDER';

export const CLUSTER_MENU_TABLE_ID = 'clusters';
export const SYSTEM_CHUNKS_TABLE_ID = 'system/chunks';

export const FIELD_AUTO = '__auto__';
